<template>
  <el-card shadow="always" class="el-main-card table-container" ref="tableContainer">
    <el-table :data="tableData" v-loading="tableConfig.loading" style="width: 100%" ref="sortTable"
              :header-cell-style="{ textAlign: tableConfig.textAlign }"
              :cell-style="{ textAlign: tableConfig.textAlign }" :max-height="tableConfig.height"
              @sort-change="sortChange" fit highlight-current-row element-loading-text="正在努力加载中...">
      <!-- 多选框 -->
      <el-table-column v-if="tableConfig.selection" type="selection" width="55"></el-table-column>
      <el-table-column type="index" v-if="tableConfig.index" :index="indexMethod"/>

      <template v-for="item in tableConfig.tHead" :key="item.field">
        <!-- v-slot -->
        <el-table-column v-if="item.columnType === 'slot'" :prop="item.field" :label="item.label" :width="item.width"
                         :sortable="item.sortable">
          <template #default="{ row }">
            <slot :name="item.slotName" :data="row"></slot>
          </template>
        </el-table-column>

        <el-table-column v-else-if="item.render" :prop="item.field" :label="item.label" :width="item.width"
                         :sortable="item.sortable">
          <template #default="{ row }"> {{ item.render(row) }}</template>
        </el-table-column>

        <!-- 文本数据渲染 -->
        <el-table-column v-else :prop="item.field" :label="item.label" :width="item.width" :sortable="item.sortable"
                         show-overflow-tooltip>
        </el-table-column>
      </template>
    </el-table>
  </el-card>

</template>

<script>
import {nextTick, onBeforeMount, onMounted, reactive, toRefs} from "vue";

export default {
  props: {
    config: {
      type: Object,
      default: () => {
      },
    },
    tableData: {
      type: Array,
      default: [],
    },
  },
  setup(props, {emit}) {
    let data = reactive({
      tableConfig: {
        loading: false,
        selection: true,
        textAlign: 'center',
        tHead: [],
        height: 0
      },
    });
    /**
     * 方法
     */ // 初始化table项 // 匹配相同的key,如果存在，则替换

    const initTableConfig = () => {
      let configData = props.config;
      let keys = Object.keys(data.tableConfig);
      for (const key in configData) {
        if (keys.includes(key)) {
          data.tableConfig[key] = configData[key];
        }
      }
    }; // 排序

    let sortChange = (e) => {
      emit("handleSortChange", e);
    };

    let indexMethod = (index) => {
      return index + 1;
    };

    const getTableMaxHeight = () => {
      let box = document.querySelector(".table-container").attributes;
      let box_clientHeight = box[0].ownerElement.clientHeight;
      data.tableConfig.height = box_clientHeight - 50;
    }

    const open = () => {
      data.tableConfig.loading = true;
    }

    const close = () => {
     setTimeout(() => {
       data.tableConfig.loading = false;
     }, 1000);
    }

    onBeforeMount(() => {
      initTableConfig();
    });

    onMounted(async () => {
      await nextTick();

      getTableMaxHeight();
      window.onresize = () => {//用于使表格高度自适应的方法
        getTableMaxHeight();//获取容器当前高度，重设表格的最大高度
      }

    });

    return {
      ...toRefs(data),
      sortChange,
      indexMethod,
      open,
      close
    };
  },
};
</script>

<style scoped>
.el-main-card {
    width: 98%;
    height: 68vh;
    background: $color-2;
}


</style>
